export enum LocalStorage {
  TPCI_ID = 'tpci-id',
  THREADSTONE_ID = 'threadstone-id',
}
